import { IGtm } from "web/types/Gtm";

const buildGtmPayload = (params: {
  eventName: string;
  url?: string;
  options: IGtm;
  resolvedOneKcId?: string | null;
}) => {
  const { eventName, url, options, resolvedOneKcId } = params;

  const base = {
    event: eventName,
    ...(url ? { url } : {}),
    ...options,
  };

  if (eventName === "virtualPageView") {
    const onekc = options.onekc_id ?? resolvedOneKcId;
    return onekc ? { ...base, onekc_id: onekc } : base;
  }

  return base;
};

export default buildGtmPayload;
